import { useState, type ReactNode } from 'react';
import './collapsed-bin.css';

/**
 * Nothing suppressed goes into nothing (ui-design §3.6): a countable line that
 * opens into a read-only list. Uses so far: the names an earlier answer ruled
 * out, the candidates a more-prose round held, a section's source notes, and the
 * run's own timeline.
 *
 * `aria-expanded` states the obvious for a screen reader and, since §3h, drives
 * the disclosure caret in CSS — the same mark the brief's findings line carries,
 * so the two disclosures in this system look like one idea.
 */
export function CollapsedBin({
  label,
  openLabel,
  children,
}: {
  label: string;
  openLabel?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="bin">
      <button
        type="button"
        className="linkish"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? (openLabel ?? label) : label}
      </button>
      {open ? <div className="bin-body">{children}</div> : null}
    </div>
  );
}
